import React from 'react';
import DOMPurify from 'dompurify';
import { Box, Typography } from '@mui/material';

/** Stored on ClientInbox.MessageText for tag-aging portal reminders (single-tag table). */
export const TAG_AGING_INBOX_HTML_MARKER = '<!-- tag-aging-inbox -->';

export function isLikelyHtmlInboxMessage(text: string): boolean {
  const s = (text || '').trim();
  if (!s) return false;
  if (s.includes(TAG_AGING_INBOX_HTML_MARKER)) return true;
  return /<\/?[a-z][\s\S]*?>/i.test(s);
}

export function sanitizeInboxHtml(html: string): string {
  return DOMPurify.sanitize(html);
}

type InboxMessageBodyProps = {
  text: string;
  variant?: 'body2' | 'caption';
};

/** Renders plain filer notes or sanitized HTML (tag-aging table). */
export function InboxMessageBody({ text, variant = 'body2' }: InboxMessageBodyProps) {
  if (!text?.trim()) {
    return <Typography sx={{ color: 'text.secondary' }}>No message content</Typography>;
  }
  if (isLikelyHtmlInboxMessage(text)) {
    return (
      <Box
        sx={{
          fontSize: variant === 'body2' ? '0.875rem' : '0.75rem',
          color: 'text.primary',
          lineHeight: 1.5,
          maxWidth: '100%',
          overflowX: 'auto',
          '& table': { minWidth: 480 },
        }}
        dangerouslySetInnerHTML={{ __html: sanitizeInboxHtml(text) }}
      />
    );
  }
  return (
    <Typography
      variant={variant}
      component="pre"
      sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: 'text.primary' }}
    >
      {text}
    </Typography>
  );
}
